import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiX } from 'react-icons/fi';
import './CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
    functionality: false
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    const allAccepted = { necessary: true, analytics: true, marketing: true, functionality: true };
    localStorage.setItem('cookie_consent', JSON.stringify({ ...allAccepted, timestamp: new Date().toISOString() }));
    setVisible(false);
  };

  const acceptSelected = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({ ...preferences, timestamp: new Date().toISOString() }));
    setVisible(false);
  };

  const rejectAll = () => {
    const minimal = { necessary: true, analytics: false, marketing: false, functionality: false };
    localStorage.setItem('cookie_consent', JSON.stringify({ ...minimal, timestamp: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-inner">
        <div className="cookie-header">
          <div className="cookie-icon">
            <FiShield />
          </div>
          <div className="cookie-text">
            <h4>We Value Your Privacy</h4>
            <p>
              We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.
              By clicking "Accept All", you consent to our use of cookies. Read our{' '}
              <Link to="/cookies">Cookie Policy</Link> and <Link to="/privacy">Privacy Policy</Link> for more information.
            </p>
          </div>
          <button className="cookie-dismiss" onClick={rejectAll} aria-label="Dismiss">
            <FiX />
          </button>
        </div>

        {showPreferences && (
          <div className="cookie-preferences">
            <div className="cookie-pref-item">
              <div className="cookie-pref-info">
                <strong>Strictly Necessary</strong>
                <span>Required for the website to function. Cannot be disabled.</span>
              </div>
              <label className="cookie-toggle disabled">
                <input type="checkbox" checked disabled />
                <span className="cookie-slider"></span>
              </label>
            </div>
            <div className="cookie-pref-item">
              <div className="cookie-pref-info">
                <strong>Analytics</strong>
                <span>Help us understand how visitors interact with our website.</span>
              </div>
              <label className="cookie-toggle">
                <input
                  type="checkbox"
                  checked={preferences.analytics}
                  onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
                />
                <span className="cookie-slider"></span>
              </label>
            </div>
            <div className="cookie-pref-item">
              <div className="cookie-pref-info">
                <strong>Marketing</strong>
                <span>Used to deliver relevant advertisements and track ad performance.</span>
              </div>
              <label className="cookie-toggle">
                <input
                  type="checkbox"
                  checked={preferences.marketing}
                  onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
                />
                <span className="cookie-slider"></span>
              </label>
            </div>
            <div className="cookie-pref-item">
              <div className="cookie-pref-info">
                <strong>Functionality</strong>
                <span>Enable personalized features and remember your preferences.</span>
              </div>
              <label className="cookie-toggle">
                <input
                  type="checkbox"
                  checked={preferences.functionality}
                  onChange={(e) => setPreferences({ ...preferences, functionality: e.target.checked })}
                />
                <span className="cookie-slider"></span>
              </label>
            </div>
          </div>
        )}

        <div className="cookie-actions">
          <button className="cookie-btn cookie-btn-outline" onClick={() => setShowPreferences(!showPreferences)}>
            {showPreferences ? 'Hide Preferences' : 'Customize'}
          </button>
          <button className="cookie-btn cookie-btn-secondary" onClick={rejectAll}>
            Reject All
          </button>
          {showPreferences ? (
            <button className="cookie-btn cookie-btn-primary" onClick={acceptSelected}>
              Save Preferences
            </button>
          ) : (
            <button className="cookie-btn cookie-btn-primary" onClick={acceptAll}>
              Accept All
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
